<script setup lang="ts">
import PovliLogo from '../components/PovliLogo.vue'
</script>

<template>
  <main class="grid min-h-dvh place-items-center bg-paper px-6 text-center text-ink">
    <div>
      <PovliLogo />
      <h1 class="mt-8 font-serif text-5xl font-semibold tracking-tight">Stories worth staying up for.</h1>
      <p class="mx-auto mt-4 max-w-md text-lg leading-8 text-muted">Read immersive stories on the web, then continue in the Povli Android app.</p>
      <RouterLink to="/privacy" class="mt-8 inline-block text-sm font-semibold text-muted underline underline-offset-4">Privacy Policy</RouterLink>
    </div>
  </main>
</template>
